import { Typography } from '~/shared/ui/Typography/Typography';

import { useLocalization } from '../../localization/localization';

import { Root } from './ErrorBoundary.ui';

export const ErrorBoundary = () => {
  const { t } = useLocalization();

  return (
    <Root>
      <Typography.H1>{t('unknownError')}</Typography.H1>
    </Root>
  );
};
